/* Steep theme scripts. Each block only runs if its section is on the page. */
(function () {
  'use strict';
  var S = window.Steep = window.Steep || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    var withCommas = function (v, dec) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas(n, 0);
      if (key === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withCommas(n, 2);
    });
  }

  /* ---------- header menu ---------- */
  var menu = $('#menu'), toggle = $('#menuToggle');
  if (menu && toggle) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- breathing word (ritual teaser) ---------- */
  var bw = $('#breathWord');
  if (bw) {
    if (reduce) { bw.textContent = 'breathe slowly'; }
    else { var t0 = performance.now(); setInterval(function () { var s = ((performance.now() - t0) / 1000) % 10; bw.textContent = s < 4 ? 'breathe in' : 'breathe out'; }, 500); }
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim');
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var cart = { items: [], total_price: 0, item_count: 0 };

  function openBag() { if (!drawer) return; drawer.classList.add('open'); scrim.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); var c = $('#closeBag'); if (c) c.focus(); }
  function closeBag() { if (!drawer) return; drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-open-bag]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openBag(); }); });
  if (drawer) {
    $('#closeBag').addEventListener('click', closeBag);
    scrim.addEventListener('click', closeBag);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBag(); });
  }

  function renderCart() {
    $$('[data-bag-count]').forEach(function (el) { el.textContent = cart.item_count || 0; });
    if (!drawer) return;
    var list = $('#dItems');
    list.innerHTML = '';
    (cart.items || []).forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'line';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : (S.heroImage || '');
      row.innerHTML = '<img src="' + img + '" alt=""><div><b></b><small></small><div class="qty"><button type="button" aria-label="Remove one">−</button><span></span><button type="button" aria-label="Add one">+</button></div></div><b class="lp"></b>';
      row.querySelector('div > b').textContent = it.product_title + (it.variant_title ? ' · ' + it.variant_title : '');
      row.querySelector('small').textContent = formatMoney(it.final_price) + ' each';
      row.querySelector('.qty span').textContent = it.quantity;
      row.querySelector('.lp').textContent = formatMoney(it.final_line_price);
      var bs = row.querySelectorAll('.qty button');
      bs[0].addEventListener('click', function () { change(it.key, it.quantity - 1); });
      bs[1].addEventListener('click', function () { change(it.key, it.quantity + 1); });
      list.appendChild(row);
    });
    if (!cart.item_count) {
      list.innerHTML = '<div class="empty"><p>Your bag is empty. Your ten minutes are waiting.</p><a class="btn btn-quiet" href="/collections/all">Shop the stick</a></div>';
    }
    var min = S.freeShippingMin || 3000, flat = S.flatShipping || 499;
    var total = cart.total_price || 0;
    var ship = !cart.item_count ? 0 : (total >= min ? 0 : flat);
    $('#subT').textContent = formatMoney(total);
    $('#shipT').textContent = !cart.item_count ? '—' : (ship === 0 ? 'Free' : formatMoney(ship));
    $('#totT').textContent = formatMoney(total + ship);
    var left = Math.max(0, min - total);
    $('#shipMsg').textContent = left === 0 && cart.item_count ? 'You unlocked free shipping.' : 'Add ' + formatMoney(left) + ' more for free shipping';
    $('#shipFill').style.width = Math.min(100, total / min * 100) + '%';
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderCart(); })
      .catch(function () {});
  }
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return loadCart(); })
      .then(openBag);
  }
  function change(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderCart(); });
  }
  window.Steep.addToCart = addToCart;
  loadCart();

  /* ---------- product form (main-product, featured product) ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    var nowEl = $('[data-price-now]', form), wasEl = $('[data-price-was]', form), saveEl = $('[data-save]', form), btn = $('[data-add-label]', form);
    function selected() { return form.querySelector('input[name="id"]:checked') || form.querySelector('[name="id"]'); }
    function update() {
      var r = selected(); if (!r || !r.dataset) return;
      if (nowEl && r.dataset.price) nowEl.textContent = r.dataset.price;
      if (wasEl) { wasEl.textContent = r.dataset.compare || ''; wasEl.hidden = !r.dataset.compare; }
      if (saveEl) { saveEl.textContent = r.dataset.save || ''; saveEl.hidden = !r.dataset.save; }
      if (btn && r.dataset.price) btn.textContent = (btn.dataset.addLabel || 'Add to bag') + ' · ' + r.dataset.price;
    }
    form.addEventListener('change', update);
    form.addEventListener('submit', function (e) {
      if (!drawer) return; // fall back to normal form post
      e.preventDefault();
      var r = selected(); if (!r) return;
      var status = $('[data-form-status]', form);
      addToCart(r.value, 1).catch(function () { if (status) status.textContent = 'Sorry, that pack could not be added. Please try again.'; });
    });
    update();
  });

  /* gallery thumbs */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('.thumb', g).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.thumb', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        main.innerHTML = t.innerHTML;
        var img = main.querySelector('img'); if (img) { img.alt = t.getAttribute('aria-label') || ''; img.removeAttribute('style'); if (t.dataset.style) img.setAttribute('style', t.dataset.style); }
      });
    });
  });

  /* ---------- rhythm quiz ---------- */
  $$('[data-quiz]').forEach(function (quiz) {
    var packs = {};
    try { JSON.parse($('[data-quiz-packs]', quiz).textContent).forEach(function (p) { if (p.sticks > 0) packs[p.sticks] = p; }); } catch (e) { packs = {}; }
    var DAYS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
    var PLANS = { 3: [1, 3, 6], 2: [2, 6], 1: [6] };
    var rec = null;
    function val(n) { var r = quiz.querySelector('input[name="' + n + '"]:checked'); return r ? r.value : ''; }
    function pick(times) { if (packs[times]) return packs[times]; var ks = Object.keys(packs).map(Number).sort(function (a, b) { return Math.abs(a - times) - Math.abs(b - times); }); return ks.length ? packs[ks[0]] : null; }
    function render() {
      var skin = val('skin'), shine = val('shine'), habit = val('habit');
      var times = skin === 'oily' ? 3 : skin === 'combo' ? 2 : 1;
      if (skin === 'combo' && shine === 'early') times = 3;
      if (skin === 'dry') times = 1;
      if (skin === 'normal' && (shine === 'early' || shine === 'lunch')) times = 2;
      var words = { 3: 'Three calm evenings a week', 2: 'Two calm evenings a week', 1: 'One calm evening a week' };
      $('[data-quiz-title]', quiz).textContent = words[times];
      var wk = $('[data-quiz-week]', quiz); wk.innerHTML = '';
      DAYS.forEach(function (d, i) { var el = document.createElement('div'); if (PLANS[times].indexOf(i) > -1) el.className = 'on'; el.innerHTML = '<i></i>' + d; wk.appendChild(el); });
      var zone = skin === 'combo' ? 'Keep it on your forehead, nose and chin; let your cheeks rest.' : skin === 'dry' ? 'Stick to your T-zone and follow with a rich moisturizer.' : 'Swipe it over your whole T-zone, or anywhere that gets shiny.';
      var start = habit === 'never' ? ' Since masks never stuck before, start with one evening this week and build from there.' : habit === 'weekly' ? ' You already have the habit, now without the mess.' : ' Pick evenings you already slow down, like after a shower.';
      var last = { 3: 'At this pace, a 3-pack lasts about three months.', 2: 'At this pace, a 2-pack lasts about two to three months.', 1: 'At this pace, one stick lasts about two months.' };
      $('[data-quiz-text]', quiz).textContent = zone + start + ' ' + last[times];
      rec = pick(times);
      var btn = $('[data-quiz-add]', quiz);
      if (btn) { btn.hidden = !rec; if (rec) btn.textContent = 'Add the ' + rec.label + ' · ' + rec.price; }
    }
    quiz.addEventListener('change', render);
    var addBtn = $('[data-quiz-add]', quiz);
    if (addBtn) addBtn.addEventListener('click', function () { if (rec) addToCart(rec.id, 1); });
    render();
  });

  /* ---------- ritual timer ---------- */
  var dialTime = $('#dialTime');
  if (dialTime) {
    var FULL = 600, C = 565.49;
    var PROMPTS = [[0, 'Swipe it on. Then set your phone face down.'], [60, 'Unclench your jaw. Let your tongue rest.'], [150, 'Let your shoulders drop an inch.'], [240, 'Breathe in for four. Out for six.'], [300, 'Halfway. The clay is working while you rest.'], [390, 'Notice how quiet it is when you let it be.'], [480, 'Feel the mask tighten? That means it’s drying.'], [560, 'Almost there. Warm water is waiting.'], [600, 'Rinse gently, pat dry, moisturize. Welcome back.']];
    var dialSub = $('#dialSub'), prog = $('#prog'), prompt = $('#prompt'), orb = $('#orb');
    var initialPrompt = prompt.textContent;
    var steps = $$('#steps .step');
    var startBtn = $('#startBtn'), previewBtn = $('#previewBtn'), resetBtn = $('#resetBtn');
    var timer = null, startAt = 0, scale = 1, lastPrompt = -1, breathT = null, paused = false, pausedAt = 0;
    var fmt = function (s) { s = Math.max(0, Math.ceil(s)); var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; };
    var setStep = function (i) { steps.forEach(function (s, k) { s.classList.toggle('on', k === i); }); };
    var chime = function () { try { var A = window.AudioContext || window.webkitAudioContext; if (!A) return; var ctx = new A(); [523.25, 659.25, 783.99].forEach(function (f, i) { var o = ctx.createOscillator(), g = ctx.createGain(); o.type = 'sine'; o.frequency.value = f; g.gain.setValueAtTime(0, ctx.currentTime + i * .25); g.gain.linearRampToValueAtTime(.18, ctx.currentTime + i * .25 + .05); g.gain.exponentialRampToValueAtTime(.001, ctx.currentTime + i * .25 + 2.2); o.connect(g); g.connect(ctx.destination); o.start(ctx.currentTime + i * .25); o.stop(ctx.currentTime + i * .25 + 2.4); }); } catch (e) {} };
    function tick() {
      var el = Math.min(FULL, (performance.now() - startAt) / 1000 * scale);
      dialTime.textContent = fmt(FULL - el);
      prog.style.strokeDashoffset = (C * (1 - el / FULL)).toFixed(2);
      var idx = 0; for (var i = 0; i < PROMPTS.length; i++) { if (el >= PROMPTS[i][0]) idx = i; }
      if (idx !== lastPrompt) { lastPrompt = idx; prompt.style.opacity = 0; setTimeout(function () { prompt.textContent = PROMPTS[idx][1]; prompt.style.opacity = 1; }, reduce ? 0 : 400); }
      setStep(el >= FULL ? 3 : el < 20 ? 1 : 2);
      if (el >= FULL) stop(true);
    }
    function breathLoop() { var inhale = true; orb.classList.add('in'); dialSub.textContent = 'breathe in'; breathT = setInterval(function () { inhale = !inhale; orb.classList.toggle('in', inhale); dialSub.textContent = inhale ? 'breathe in' : 'breathe out'; }, reduce ? 999999 : (scale > 1 ? 2000 : 5000)); }
    function begin(sc) { clearInterval(timer); clearInterval(breathT); scale = sc; startAt = performance.now(); lastPrompt = -1; paused = false; timer = setInterval(tick, 250); tick(); breathLoop(); startBtn.textContent = 'Pause'; previewBtn.hidden = true; resetBtn.hidden = false; }
    function stop(done) { clearInterval(timer); clearInterval(breathT); timer = null; orb.classList.remove('in'); if (done) { dialSub.textContent = 'time to rinse'; chime(); startBtn.textContent = 'Start again'; paused = false; } }
    startBtn.addEventListener('click', function () {
      if (timer) { pausedAt = performance.now(); stop(false); paused = true; startBtn.textContent = 'Resume'; dialSub.textContent = 'paused'; return; }
      if (paused) { startAt += performance.now() - pausedAt; paused = false; timer = setInterval(tick, 250); breathLoop(); startBtn.textContent = 'Pause'; return; }
      begin(1);
    });
    previewBtn.addEventListener('click', function () { begin(20); });
    resetBtn.addEventListener('click', function () { stop(false); paused = false; dialTime.textContent = '10:00'; prog.style.strokeDashoffset = C; dialSub.textContent = 'ready when you are'; prompt.textContent = initialPrompt; setStep(-1); startBtn.textContent = 'Start my 10 minutes'; previewBtn.hidden = false; resetBtn.hidden = true; });
  }

  /* ---------- copy buttons ---------- */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-copy');
      var ok = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1500); };
      var fail = function () { var c = b.previousElementSibling; if (!c) return; var r = document.createRange(); r.selectNodeContents(c); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); b.textContent = 'Selected'; };
      try { navigator.clipboard.writeText(v).then(ok, fail); } catch (e) { fail(); }
    });
  });
})();
